export default {
  darkMainTheme: '#3F51B5',
  light: '#FFF',
  shellBackground: '#f2f3f7',
  mainTheme: '#2F80EC',
};
